<template>
  <div>
    <v-img
      id="background-image"
      width="100vw"
      :aspect-ratio="1"
      height="220px"
      :src="image"
      @click.prevent="show"
    >
      <v-avatar size="72" class="profile-image" id="challenger">
        <img :src="challenger" alt="" />
      </v-avatar>

      <v-avatar size="72" class="profile-image" id="helper">
        <img :src="helper" alt="" />
      </v-avatar>
      <v-menu
        v-model="showMenu"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
      >
        <v-list>
          <v-list-item @click="selectImage">
            <v-list-item-title>앨범에서 사진 선택</v-list-item-title>
          </v-list-item>
          <v-list-item @click="setDefault">
            <v-list-item-title>기본 이미지로 변경</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-img>
    <v-file-input
      id="backgroundInput"
      v-model="selectedImage"
      style="display: none"
      ref="backgroundInput"
      type="file"
      accept="image/x-png,image/gif,image/jpeg"
    ></v-file-input>
    <overlay-loader :overlay="loading" />
    <span 
      v-if="alert"
      class="alert"
    >
      <v-icon class="alertIcon">mdi-alert</v-icon>
      {{ alertMessage }}
    </span>
  </div>
</template>
<script>
import OverlayLoader from "../OverlayLoader.vue";

export default {
  components: { OverlayLoader },
  name: "Background",
  data() {
    return {
      default: require('@/assets/images/home/home_background.jpg'),
      image: undefined,
      challenger: undefined,
      helper: undefined,
      selectedImage: undefined,

      showMenu: false,
      x: 0,
      y: 0,

      loading: false,
      alert: false,
      alertMessage: undefined,
    };
  },
  methods: {
    getBackgroundImage() {
      // this.$axios
      //   .get("/challenges/" + this.$store.getters.challengeId + "/background")
      //   .then((response) => {
      //     if (response.data.background) {
      //       this.image = response.data.background;
      //     } else {
      //       this.image = this.default;
      //     }
      //     this.challenger = response.data.challenger;
      //     this.helper = response.data.helper;
      //   });
      this.image = require('@/assets/images/home/background.jpg');
      this.challenger = require('@/assets/images/home/user1.png');
      this.helper = require('@/assets/images/home/user2.png');
    },
    show(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    selectImage() {
      document.getElementById("backgroundInput").click();
      this.alert = false;
      this.loading = true;
      // this.$refs.backgroundInput.click();
    },
    setDefault() {
      // this.$axios
      //   .delete(
      //     "/challenges/" + this.$store.getters.challengeId + "/background"
      //   )
      //   .then((response) => {
      //     this.image = this.default;
      //   });
      this.image = this.default;
    },
  },
  mounted() {
    this.getBackgroundImage();
  },
  watch: {
    selectedImage(v) {
      const fileSize = document.querySelector('#backgroundInput').files[0].size;
      if(fileSize > 5000000){
        this.loading = false;
        this.alert = true;
        this.alertMessage = '이미지 파일은 5MB 이하만 가능합니다.';
        return;
      } else {
        let formData = new FormData();

        formData.append("image", v);
       
        // this.$axios
        //   .post(
        //     "/challenges/" + this.$store.getters.challengeId + "/background",
        //     formData,
        //     {
        //       headers: {
        //         "Content-Type": "multipart/form-data",
        //       },
        //     }
        //   )
        //   .then((response) => {
        //     this.image = response.data;
        //     this.loading = false;
        //   });
        this.loading = false;
      }

    },
  },
};
</script>
<style scoped>
#background-image {
  position: relative;
}
.profile-image {
  position: absolute;
}

#challenger {
  bottom: 10px;
  left: 10px;
}

#helper {
  bottom: 10px;
  right: 10px;
}
</style>